import { render, staticRenderFns } from "./CardInfoItem.vue?vue&type=template&id=6998bf08&"
import script from "./CardInfoItem.vue?vue&type=script&lang=js&"
export * from "./CardInfoItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports